import styled from 'styled-components';
import { PageHeader } from 'ui/pageHeader';
import { colors, spacing } from 'ui/theme';
import { normalPageMaxWidth } from 'ui/theme/spacing';
import { FullWidth } from 'ui/utility/fullWidth';
import { AlertDestinationCard, CampaignAlertDefaultsCard } from './components';
import {
  AlertsFormProvider,
  AlertsModalProvider,
  DestinationsProvider,
  ProjectAlertsProvider,
} from './context';
import { Modals } from './modals';

const Container = styled.div`
  display: block;
  width: 100%;
  max-width: ${normalPageMaxWidth};
  margin-right: auto;
  margin-left: auto;
`;

const Body = styled.div`
  background: ${colors.backgroundSecondary};
  border-top: ${spacing.single} solid ${colors.borderPrimarySubtle};
  margin-bottom: -${spacing.double};
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusHalf};
  padding: ${spacing.double};
`;

const StyledPageHeader = styled(PageHeader)`
  padding: ${spacing.threeQuarter} 0 ${spacing.double};
  max-width: ${normalPageMaxWidth};
  margin: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  > div div {
    padding-top: 0;
  }
  a {
    padding-bottom: 0;
    margin-bottom: 0;
  }
`;

export const ALERTS_HEADER_ID = 'alerts-header';

export const Alerts = () => {
  return (
    <ProjectAlertsProvider>
      <DestinationsProvider>
        <AlertsModalProvider>
          <AlertsFormProvider>
            <Container>
              <StyledPageHeader
                data-test={ALERTS_HEADER_ID}
                documentTitle="Alerts"
                documentation={{
                  content: 'Documentation',
                  href: 'https://support.iterable.com/hc/en-us/articles/19437186634772-Campaign-Performance-Alerts',
                }}
              >
                Alerts
              </StyledPageHeader>
            </Container>
            <FullWidth>
              <Body>
                <Container>
                  <CampaignAlertDefaultsCard />
                  <AlertDestinationCard />
                </Container>
              </Body>
            </FullWidth>
            <Modals />
          </AlertsFormProvider>
        </AlertsModalProvider>
      </DestinationsProvider>
    </ProjectAlertsProvider>
  );
};
